<template>
  <template v-for="(inspiration, index) in props.templates" :key="inspiration.id">
    <ImageButton
      :elevate-on-hover="false"
      :small-on-mobile="false"
      :selected="isSelected(inspiration)"
      :size="props.imageButtonSize"
      @click.prevent="onInspirationClicked(inspiration, index)"
      class="justify-center items-center"
    >
      <Image :src="inspiration.url" alt="Example image" :img-classes="['object-cover checkerboard', '!h-20 !w-20']" />
      <div
        v-if="isInspirationLoading(inspiration)"
        class="top-0 bg-typo flex justify-center items-center bg-opacity-80 absolute w-full h-full"
      >
        <LoadingIcon class="text-white animate-spin" />
      </div>
    </ImageButton>
  </template>
</template>

<script setup lang="ts">
import { ImageButton, Image, LoadingIcon } from "prism";
import { PersistentStore } from "@/stores/persistent_store";
import { MagicBackgroundTemplate } from "@/modules/internal_api/magic_backgrounds";
import { useEditorStore } from "@/stores/editor_store";
import { rbgMbInspirationClickedV100 } from "kaleido-event-tracker";

export interface InspirationGalleryTilesProps {
  isLoading: boolean;
  selectedImageState: PersistentStore;
  templates: MagicBackgroundTemplate[];
  imageButtonSize: string;
}

const props = withDefaults(defineProps<InspirationGalleryTilesProps>(), {
  imageButtonSize: "default",
});

const editorStore = useEditorStore();

const isInspirationLoading = (inspiration: MagicBackgroundTemplate) =>
  isSelected(inspiration) && props.selectedImageState.selectedBackgroundLoading;

const isSelected = (inspiration: MagicBackgroundTemplate) =>
  props.selectedImageState.selectedMagicBackgroundTemplate?.id === inspiration.id;

const selectInspiration = (inspiration: MagicBackgroundTemplate) => {
  props.selectedImageState.withSnapshot(() => {
    props.selectedImageState.setSelectedMagicBackgroundTemplate(inspiration);

    props.selectedImageState.setSelectedBackgroundColor(undefined);
    props.selectedImageState.setIsBackgroundAddedByBlur(false);
    props.selectedImageState.setSelectedSearchedBackground(false);
    props.selectedImageState.unselectMagicBackground();
  });
};

const deselectInspiration = () => {
  if (editorStore.isApplyingBackgroundChanges) return;

  props.selectedImageState.withSnapshot(() => {
    props.selectedImageState.setSelectedBackgroundColor(undefined);
    props.selectedImageState.setSelectedBackgroundPhoto(undefined);
    props.selectedImageState.setSelectedMagicBackgroundTemplate(undefined);
  });
};

const onInspirationClicked = (inspiration: MagicBackgroundTemplate, index: number) => {
  isSelected(inspiration) ? deselectInspiration() : selectInspiration(inspiration);
  rbgMbInspirationClickedV100({
    image_id: editorStore.selectedImageId,
    template_id: inspiration.id,
    template_index: index,
  });
};
</script>
